import React, { useState, useEffect } from 'react'
import Addnewcard from './Addnewcard'
import PaymentCards from './paymentCards'
import axios from '../../Utils/Utility/axiosconfig'
import _, { isEmpty } from 'lodash'
import Swal from 'sweetalert2'
import './cards.css'

const Cards = (props) => {
    const [AllCard, setAllCard] = useState([])
    const [selected, setSelected] = useState([])

    const allsavedCards = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('userData'))
            const res = await axios.post('mobileapi/stripe_pm_list', {
                user_id: userData?.id,
            })

            if (res?.data?.status === 'success') {
                res.data.data.responseData.data &&
                    setAllCard(
                        res.data.data.responseData.data.filter((data) => data.type == 'card'),
                    )
                // data.selectedCard && setSelected(data.selectedCard)
            } else {
                setAllCard([])
            }
        } catch (err) {
            console.log(err)
            setAllCard([])
        }
    }

    useEffect(() => {
        allsavedCards()
    }, [])

    const updateCards = () => {
        allsavedCards()
    }

    const makePrimary = async (data) => {
        const res = await axios.post(`mobileapi/updateCard`, data)
        try {
            if (res.data.success === true) {
                updateCards()
                Swal.fire({
                    title: 'Card selected successfully',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        } catch (err) {
            console.log(err)
        }
    }

    const deleteCard = async (data) => {
        try {
            const userData = JSON.parse(localStorage.getItem('userData'))
            const res = await axios.post('mobileapi/stripe_pm_delete', {
                source_id: data.id,
                user_id: userData?.id,
            })
            if (res?.data?.status === 'success') {
                updateCards()
                Swal.fire({
                    title: 'Card Deleted Successfully',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <div>
            <div className="cardContainer">
                <div className="card-1-Container">
                    <Addnewcard upd={updateCards} />
                </div>
                {!isEmpty(AllCard) &&
                    AllCard.map((data) => (
                        <div className="card-2-Container">
                            <PaymentCards
                                value={data}
                                selectedcard={selected}
                                pr={(data) => {
                                    makePrimary(data)
                                }}
                                del={(id) => {
                                    deleteCard(data)
                                }}
                            />
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Cards
